import { createSlice } from '@reduxjs/toolkit';

export const zoomInitialState = {
  isZoom: false,
};

// Then, handle actions in your reducers:
const zoomSlice = createSlice({
  name: 'zoom',
  zoomInitialState,
  reducers: {
    // standard reducer logic, with auto-generated action types per reducer
    zoomSetState: (state, { payload }) => {
      state.isZoom = payload;
    },
  },
});

// actions generated from the slice, TODO: remove start,success,fail
export const { zoomSetState } = zoomSlice.actions;

// The reducer
export const zoomReducer = zoomSlice.reducer;
